import type { AppletLayoutProps } from '../../../applets';
import StudioShellLayout from '../../StudioShellLayout';

export default function CartographerLayout({
  children,
  title,
  subtitle,
}: AppletLayoutProps) {
  return (
    <StudioShellLayout title={title} subtitle={subtitle}>
      {children}
    </StudioShellLayout>
  );
}
